import { useState } from "react";
import { useLookupReglementsQuery } from "../../stores/OkOkStore";
import type { Reglements } from "../../types/Reglements";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";

function ReglementsList(){
    const [params,setParams]=useState<Record<string, string>>({page:"0"});
    const { data, error, isLoading } = useLookupReglementsQuery(params);
    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }
    const {translate}=useTrads();
    

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table">
                    <thead>
                        <tr>
                            <th></th>
                            
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((reglement:Reglements) => (
                            <tr key={reglement.id}>
                                <td>{reglement.id}</td>
                                <td>
                                    <NavLink to={`/reglements/${reglement.id.toString()}`}>
                                        <span className="visually-hidden">{translate('btn_voir')}</span>
                                        <i className="bi bi-eye-fill"></i>
                                    </NavLink>
                                </td>
                                <td>
                                    <NavLink to={`/reglements/${reglement.id.toString()}/edit`}>
                                        <span className="visually-hidden">{translate('btn_edit')}</span>
                                        <i className="bi bi-pencil-fill"></i>
                                    </NavLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default ReglementsList;